var map = {
	"./en.json": [
		1675,
		63
	],
	"./et.json": [
		1676,
		62
	],
	"./fi.json": [
		1677,
		61
	],
	"./lv.json": [
		1678,
		60
	],
	"./pl.json": [
		1679,
		59
	],
	"./ru.json": [
		1680,
		58
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
module.exports = webpackAsyncContext;
webpackAsyncContext.id = 1672;


//////////////////
// WEBPACK FOOTER
// ./src/i18n lazy ^\.\/.*\.json$
// module id = 1672
// module chunks = 65